<template>
  <div class="active_detail">
    <MobileHead />
    <div class="activeDetail">
      <div class="nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ $t('navbar.home') }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/active' }">{{ $t('navbar.activity') }}</el-breadcrumb-item>
          <el-breadcrumb-item :style="{ maxWidth: lang == 'zh' ? '55vw' : '50vw' }"
            ><span style="color:#006FB8; font-weight: 400;">{{ activeMsg.actTitle }}</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>

      <div class="activeContent">
        <div class="active_img">
          <div class="img_box">
            <img :src="activeMsg.column15" alt="" v-if="activeMsg.column15.substr(0,4)=='http'"/>
            <img :src="baseUrl + activeMsg.column15" alt="" v-else/>
          </div>
        </div>
      </div>

      <div class="companyDetail">
        <div class="companyName">
          <div class="left">{{ activeMsg.actTitle }}</div>
        </div>
        <div class="all_time">
          <div class="time">
            <p>{{ $t('activity.startTime') }}{{ activeMsg.startTime }}</p>
            <p>{{ $t('activity.endTime') }}{{ activeMsg.endTime }}</p>
            <p :title="activeMsg.address">{{ $t('activity.placeBooth') }}&nbsp;{{ activeMsg.address }}</p>
          </div>
        </div>
        <div class="exhibitor" @click="exDetail()">
          <div class="logo">
            <el-image>
              <div slot="error" class="image-slot">
                <img alt="" src="../../../static/占位-展商-列表.png" />
              </div>
            </el-image>
            <img :src="exData.comCover" alt="" v-if="exData.comCover.substr(0,4)=='http'" />
            <img :src="baseUrl + exData.comCover" alt="" v-else />
            <img src="../../../static/占位-展商-列表.png" alt="" v-else />
          </div>
          <div class="exhi_title">
            <p>{{ exData.companyNameC }}</p>
            <p :title="exData.boothList" v-if="exData.boothList" class="boothnum">
              {{ $t('common.boothNum1') }}&nbsp;&nbsp;<span style="color: #333333;font-weight:600" v-for="(item, index) in exData.boothList" :key="index"
                >{{ item }} &nbsp;</span
              >
            </p>
          </div>
        </div>
      </div>

      <div class="itemInfo">
        <div id="item1">
          <h3 :style="{ width: lang == 'zh' ? '24.27vw' : '45vw' }">{{ $t('activity.activityIntroduce') }}</h3>
          <p v-html="activeMsg.actContent"></p>
        </div>
      </div>
    </div>
    <div class="fun">
      <div class="collent_btn">
        <button :class="[collectFlag ? 'collentSC' : 'cancleSC']" @click="collent">
          {{ collectFlag ? $t('common.collectActivity') : $t('common.clearCollect') }}
        </button>
        <div class="share" @click="goShare">
          <div class="shareLogo"><img src="../../../static/share.png" alt="" /></div>
          <div class="shareTxt">{{ $t('common.share') }}</div>
        </div>
      </div>
    </div>
    <GoLogin :dialogVisible.sync="dialogVisible" @func="getMsgFormSon" @funcancel="getCancel" />
    <Share
      :shareVisiable="shareVisiable"
      @copyLink="copyLink"
      @closePannel="closePannel"
      :shareContentTitle="shareContentTitle"
      :shareContentUrl="shareContentUrl"
    />
    <Foot style="margin-bottom:15.2vw" />
  </div>
</template>

<script>
import MobileHead from '../../../common/mobile/head.vue';
import Foot from '../../../common/mobile/footBottom.vue';
import { forMat } from '../../../../utils/common.js';
import { actDetail, exMsg, collectActive } from '../../../../api/activePage'; //导入详情接口
import GoLogin from '../../../common/mobile/goLogin.vue'; //登录提示框
import Share from '../../../common/mobile/share.vue';
import * as tools from '../../../../utils/roulink';

export default {
  name: '',
  components: { MobileHead, Foot, GoLogin, Share },

  data() {
    return {
      shareVisiable: false,
      baseUrl: forMat(),
      id: this.$route.query.id, //活动id
      activeMsg: {}, //活动信息对象
      collectFlag: true,
      exData: {
        //展商信息
        companyNameC: '', // 中文名称
        comCover: '', //公司Logo
        boothList: [], //展位号
      },
      lang: '',
      dialogVisible: false,
      shareVisiable: false,
      shareContentTitle: '',
      shareContentUrl: '',
    };
  },
  created() {
    this.activeDetail({ id: this.id });
    this.lang = localStorage.getItem('lang');
    document.documentElement.scrollTop = 0;
  },
  methods: {
    // 复制链接
    closePannel(data) {
      this.shareVisiable = data;
    },
    copyLink() {},
    goShare() {
      this.shareVisiable = true;
      this.shareContentTitle = this.activeMsg.actTitle;
      this.shareContentUrl = window.location.href;
    },
    //获取当前的活动信息
    async activeDetail(dataItem) {
      let { data } = await actDetail(dataItem);
      this.activeMsg = data.data; //把活动信息信息赋值给activeMsg
      this.activeMsg.collectStatus == 0 ? (this.collectFlag = true) : (this.collectFlag = false);
      try {
        let ex = await exMsg({ id: this.activeMsg.exhId }); //获取到展商信息
        this.exData = ex.data.data;
        var arr = [];
        ex.data.data.hzBoothList.map((item) => {
          arr.push(item.boothNum);
        });
        this.exData.boothList = arr;
      } catch (err) {
        console.log(err);
      }
    },
    getCancel(data) {
      this.dialogVisible = data;
    },
    getMsgFormSon(data) {
      this.dialogVisible = data;
      console.log(123);
      tools.login(3);
    },
    //收藏活动
    async collent() {
      let collObj = {};
      const state = this.activeMsg.collectStatus;
      state == 0 ? (collObj.flag = true) : (collObj.flag = false);
      collObj.objId = String(this.activeMsg.id);
      collObj.type = 4;
      try {
        const { data } = await collectActive(collObj);
        if (state == 0) {
          if (data.code == 200) {
            this.collectFlag = false;
            this.activeMsg.collectStatus = !this.activeMsg.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
            this.getAct(this.actUpDatas);
            return false;
          } else {
            // this.$message({
            //   showClose: true,
            //   message: data.msg,
            //   type: "warning",
            // });
            // tools.login(3);
          }
        } else {
          if (data.code == 200) {
            this.collectFlag = true;
            this.activeMsg.collectStatus = !this.activeMsg.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'success',
            });
            this.getAct(this.actUpDatas);
            return false;
          } else {
            // tools.login(3);
          }
        }
      } catch (err) {
        if (err == 'noLogin') {
          this.dialogVisible = true;
        }
        console.log(err);
      }
    },

    //进入展商详情
    exDetail() {
      this.$router.push({
        name: 'exhibition_det',
        query: {
          id: this.activeMsg.exhId,
        },
      });
    },

    //活动切换
    toggle() {
      if (this.collent_toggle == true) {
        this.collent_toggle = false;
      } else if (this.collent_toggle == false) {
        this.collent_toggle = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.active_detail {
  .activeDetail {
    margin: 13.3vw auto;

    .nav {
      padding: 4vw;
      box-sizing: border-box;
    }
    .activeContent {
      margin-top: 6.4vw;
      padding-left: 4vw;
      padding-right: 4vw;
      box-sizing: border-box;
      width: 100%;
      height: 53.3vw;
      display: flex;

      .active_img {
        width: 100%;
        height: 53.3vw;

        img {
          width: 100%;
          height: 53.3vw;
        }
      }
      .option {
        width: calc(100% + 0.3vw);
        height: 14.4vw;
        // border: 1px solid red;
        display: flex;
        align-items: center;
        justify-content: space-around;
        font-size: 2.6vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        background: rgba(0, 111, 184, 0.2);
        color: #000000;

        img {
          vertical-align: middle;
        }

        .vr {
          position: relative;
          cursor: pointer;
          img {
            width: 9.87vw;
            height: 3.3vw;
          }
          div {
            margin-top: 0.5vw;
          }

          ul {
            position: absolute;
            display: none;
            background: #ffffff;
            box-shadow: 0px 0px 51px 0px #e8ecf0;
            //top: 35px;

            li {
              width: 166px;
              height: 40px;
              line-height: 40px;
              // border: 1px solid red;
            }

            li:hover {
              background: #ededed;
              color: #006fb8;
            }
          }

          &:hover {
            ul {
              display: block;
            }
          }
        }

        .picture {
          position: relative;
          img {
            width: 9.3vw;
            height: 4vw;
          }
          div {
            margin-top: 0.5vw;
          }
          ul {
            position: absolute;
            display: none;
            background: #ffffff;
            box-shadow: 0px 0px 51px 0px #e8ecf0;
            //top: 35px;

            li {
              width: 166px;
              height: 40px;
              line-height: 40px;
              // border: 1px solid red;
            }

            li:hover {
              background: #ededed;
              color: #006fb8;
            }
          }

          &:hover {
            ul {
              display: block;
            }
          }
        }

        .vedio {
          position: relative;
          img {
            width: 9.3vw;
            height: 4vw;
          }
          div {
            margin-top: 0.5vw;
          }
          ul {
            position: absolute;
            display: none;
            background: #ffffff;
            box-shadow: 0px 0px 51px 0px #e8ecf0;
            //top: 35px;

            li {
              width: 166px;
              height: 40px;
              line-height: 40px;
              // border: 1px solid red;
            }

            li:hover {
              background: #ededed;
              color: #006fb8;
            }
          }

          &:hover {
            ul {
              display: block;
            }
          }
        }
      }
    }
    .companyDetail {
      width: 100%;
      margin-top: 6.5vw;
      padding-left: 4vw;
      padding-right: 4vw;
      box-sizing: border-box;
      .companyName {
        width: 100%;
        .left {
          font-size: 4.8vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 6vw;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
      .all_time {
        margin-top: 2.5vw;
        font-size: 3.7vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        .time {
          width: 100%;
          p {
            margin-top: 3.9vw;
            font-size: 3.7vw;

            img {
              vertical-align: middle;
            }
          }
        }
      }
      .exhibitor {
        width: 100%;
        height: 22.9vw;
        display: flex;
        margin-top: 10.67vw;
        border: 1px solid #e0e0e0;
        .logo {
          width: 29.87vw;
          height: 22.9vw;
          //padding: 0 56px;
          box-sizing: border-box;
          border-right: 1px solid #e0e0e0;
          flex-shrink: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 2.6vw 4.8vw;
          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
        .exhi_title {
          box-sizing: border-box;
          padding-left: 3.9vw;
          padding-bottom: 4vw;
          flex: 1;
          p {
            margin-top: 4vw;
            max-width: 44.7vw;
          }
          .boothnum {
            margin-top: 2.4vw;
          }
        }
      }
    }

    .itemInfo {
      // 展商介绍

      h3 {
        font-size: 4.8vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-bottom: 6.4vw;
        color: #006fb8;
        width: 24.27vw;
        border-left: 0.4vw solid #006fb8;
        border-right: 0.4vw solid #006fb8;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 4.8vw;
      }
      #item1 {
        margin-top: 10.67vw;
        padding-left: 4vw;
        padding-right: 4vw;
        box-sizing: border-box;
        p {
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          font-size: 3.7vw;
        }
      }
    }
  }
  .fun {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 15.2vw;
    background: #ffffff;
    box-shadow: 0px 0px 13.3vw 0px rgba(109, 109, 109, 0.35);
    z-index: 99;
    padding: 2.6vw 4vw;
    box-sizing: border-box;
    .collent_btn {
      display: flex;
      .collentSC {
        border: none;
        width: 79.3vw;
        height: 9.6vw;
        background: #fdd000;
        border-radius: 4px;
        color: #006fb8;
        font-size: 4.3vw;
      }

      .cancleSC {
        border: none;
        width: 79.3vw;
        height: 9.6vw;
        background: #aaa9a3;
        border-radius: 4px;
        color: white;
        font-size: 4.3vw;
      }
      .share {
        margin-left: 5.3vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .shareLogo {
          width: 100%;
          height: 4.8vw;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        img {
          color: #666666;
          max-width: 100%;
          max-height: 100%;
          vertical-align: middle;
        }
        .shareTxt {
          font-size: 3.2vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
        }
      }
    }
  }
}
</style>
<style scoped>
.el-breadcrumb__item >>> .el-breadcrumb__inner {
  color: #333 !important;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.el-breadcrumb >>> .el-breadcrumb__item:nth-child(3) {
  max-width: 55vw;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
</style>
